export default "__VITE_ASSET__B_7A7dfZ__"